/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-shadow */
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useToast } from "@aleaplay/web-components/ui/Toast";

import { ToastData } from "@/v1/types/global";
import { ToastModifier } from "@/v1/utils/constants";
import { useToastStore } from "@/v2/store/useToastStore";

export const useToastProxy = () => {
  const [seenToasts, setSeenToasts] = useState<ToastData[]>([]);
  const [addToast] = useToast();
  const newToast = useToastStore((state) => state.toast);
  const intl = useIntl();

  const isToastUnique = (newToast: ToastData, seenToasts: ToastData[]): boolean => {
    return !seenToasts.some(
      (seenToast) =>
        seenToast.type === newToast.type &&
        seenToast.title === newToast.title &&
        seenToast.message === newToast.message,
    );
  };

  const defaultToastConfig = {
    [ToastModifier.SUCCCESS]: {
      title: intl.formatMessage({ id: "label.success" }),
      timeout: 3000,
      type: ToastModifier.SUCCCESS,
    },
    [ToastModifier.ERROR]: {
      title: intl.formatMessage({ id: "label.error" }),
      content: intl.formatMessage({ id: "label.generic-error" }),
      timeout: 5000,
      type: ToastModifier.ERROR,
    },
    [ToastModifier.WARNINIG]: {
      timeout: 10000,
    },
  } as Record<string, ToastData>;

  useEffect(() => {
    if (newToast && typeof newToast === "object" && isToastUnique(newToast, seenToasts)) {
      addToast({
        ...(newToast.type ? defaultToastConfig[newToast.type] : {}),
        ...newToast,
      });
      setSeenToasts((prev) => [...prev, newToast]);
    }
    setTimeout(() => {
      setSeenToasts([]);
    }, 3000);
  }, [newToast]);

  return null;
};
